module.exports = __webpack_public_path__ + "static/media/central-element.6062a57a.svg";